import withDatas from '../withDatas'

import defaultStyles from './styles'

const withDatasGrid = withDatas(defaultStyles) ;

export default withDatasGrid ;